// ##################################################### //
// #               AUTO GENERATED FILE                 # //
// # Run `npm run icon` to update this file            # //
// #                                                   # //
// # Any changes made after this time will be          # //
// # overwritten the next time the script is executed. # //
// ##################################################### //

/**
 * Hash for cache busting
 */
export const ADMIN_APP_ICON_HASH = '79cf7594cbf25959c742efac123a5f1a';

/**
 * Enum for all available icons
 */
export enum ADMIN_APP_ICON {
  CHEVRON_STOP_LEFT_L = 'chevron-stop-left-L',
  CHEVRON_STOP_RIGHT_L = 'chevron-stop-right-L',
  UNDO_S = 'undo-S',
}
